export function getFinancialReportColumns() {
    return [
        { header: ['Proces', 'Proces ID'], key: 'processId' },
        { header: ['Proces', 'Txcs proces ID'], key: 'txcsProcesId' },
        { header: ['Proces', 'Migratiedatum'], key: 'migrationDateTime' },
        { header: ['Proces', 'Mogelijk testgeval'], key: 'processTestCase' },
        { header: ['Proces', 'Dienst'], key: 'serviceName' },
        { header: ['Proces', 'Dienstsoort'], key: 'serviceType' },
        { header: ['Proces', 'Indirecte aanvraag'], key: 'isDirectProcedureAdded' },
        { header: ['Proces', 'Creatiedatum'], key: 'creatieDatum', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Proces', 'Status'], key: 'status' },
        {
            header: ['Proces', 'Aanvraag verzonden'],
            key: 'datumVerzending',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Proces', 'Sluitdatum'], key: 'sluitDatum', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Proces', 'Reden geen bekosting'], key: 'reasonNoInvoiceOrDeclaration' },
        { header: ['Proces', 'Reden geen bek. ingest.'], key: 'fundingMutationReason' },
        { header: ['Proces', 'Bekostingsfout'], key: 'fundingError' },
        { header: ['Proces', 'Afhandelingsinformatie'], key: 'fundingErrorInformation' },
        { header: ['Proces', 'Anders doorverwezen?'], key: 'evaluationOtherwiseReferPatient' },
        { header: ['Proces', 'Alsnog doorverwijzen?'], key: 'evaluationAfterwardsReferPatient' },
        { header: ['Proces', 'Geholpen?'], key: 'evaluationReportHelpful' },
        { header: ['Proces', 'Leerzaam?'], key: 'evaluationReportInstructive' },
        { header: ['Proces', '=> consult?'], key: 'previousRequestId' },
        { header: ['Proces', 'Aanvraag ontvanger'], key: 'recipientOrganizationName' },

        { header: ['Aanvraag', 'Verzenddatum'], key: 'dateSent' },
        { header: ['Aanvraag', 'Reden geen uitb.'], key: 'requestPayoutError' },
        { header: ['Aanvraag', 'Reden geen uitb. ingest.'], key: 'requestPayoutMutationReason' },
        { header: ['Aanvraag', 'Aanv. organisatie ID'], key: 'requesterOrganizationTxcsId' },
        { header: ['Aanvraag', 'Aanv. organisatienaam'], key: 'requesterOrganizationName' },
        { header: ['Aanvraag', 'Verwijst naar'], key: 'refersTo' },
        { header: ['Aanvraag', 'Aanv. org. relatienr.'], key: 'requesterOrganizationRelationNumber' },
        {
            header: ['Aanvraag', 'Aanv. org. prijs'],
            key: 'requesterServiceOrganizationSettingCompensationPayoutRequest',
        },
        { header: ['Aanvraag', 'Aanv. org. emailadres'], key: 'requesterOrganizationEmailAddressRequestInbox' },
        { header: ['Aanvraag', 'Aanv. org. fin. email'], key: 'requesterOrganizationEmailAddressPayouts' },
        { header: ['Aanvraag', 'Aanv. grp. naam'], key: 'groupName' },
        { header: ['Aanvraag', 'Aanv. grp. relatienr.'], key: 'groupRelationNumber' },
        { header: ['Aanvraag', 'Aanv. grp. fin. email'], key: 'groupFinancialEmailAddress' },
        { header: ['Aanvraag', 'Aanv. grp. prijs'], key: 'compensationPayoutRequestGroupSetting' },
        { header: ['Aanvraag', 'Aanvrager ID'], key: 'requesterPractitionerUid' },
        { header: ['Aanvraag', 'Aanvragernaam'], key: 'requesterPractitionerName' },
        { header: ['Aanvraag', 'Uitv. prijs'], key: 'serviceConsumerCompensationPayoutRequest' },
        { header: ['Aanvraag', 'Uitv. relatienr'], key: 'requesterEmploymentRelationNumber' },
        { header: ['Aanvraag', 'Pers. Emailadres'], key: 'requesterEmploymentEmailAddress' },
        { header: ['Aanvraag', 'Financieel emailadres'], key: 'requesterEmploymentEmailAddressPayouts' },

        { header: ['Patient', 'Patient ID'], key: 'patientId' },
        { header: ['Patient', 'Huisartsnaam'], key: 'careProviderPractitioner' },

        {
            header: ['Biometrie', 'Verzenddatum'],
            key: 'procedureDate',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Biometrie', 'Reden geen uitb.'], key: 'procedurePayoutError' },
        { header: ['Biometrie', 'Reden geen uitb. ingest.'], key: 'procedurePayoutMutationReason' },
        { header: ['Biometrie', 'Uitv. grp. naam'], key: 'nameGroupProcedure' },
        { header: ['Biometrie', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupProcedure' },
        { header: ['Biometrie', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupProcedure' },
        { header: ['Biometrie', 'Uitv. grp. prijs'], key: 'compensationPayoutProcedureGroupSetting' },
        { header: ['Biometrie', 'Uitv. organisatie ID'], key: 'procedureOrganizationTxcsId' },
        { header: ['Biometrie', 'Uitv. organisatienaam'], key: 'procedureOrganizationName' },
        { header: ['Biometrie', 'Uitv. org. relatienr'], key: 'procedureOrganizationRelationNumber' },
        { header: ['Biometrie', 'Uitv. org. prijs'], key: 'compensationPayoutBioOrganizationSetting' },
        { header: ['Biometrie', 'Uitv. org. emailadres'], key: 'procedureOrganizationEmailAddressRequestInbox' },
        { header: ['Biometrie', 'Uitv. org. fin. email'], key: 'procedureOrganizationEmailAddressPayouts' },
        { header: ['Biometrie', 'Uitv. biometrist ID'], key: 'procedurePractitionerUid' },
        { header: ['Biometrie', 'Uitv. biometristnaam'], key: 'procedurePractitionerName' },
        { header: ['Biometrie', 'Uitv. prijs'], key: 'compensationPayoutBio' },
        { header: ['Biometrie', 'Uitv. relatienr'], key: 'procedureEmploymentRelationNumber' },
        { header: ['Biometrie', 'Pers. emailadres'], key: 'procedurePractitionerEmailAddress' },
        { header: ['Biometrie', 'Financieel emailadres'], key: 'procedureEmploymentEmailAddress' },
        { header: ['Biometrie', 'Revers. test afg.'], key: 'reverseTest' },
        { header: ['Biometrie', 'Ketenpatiënt'], key: 'ketenPatient' },
        { header: ['Biometrie', 'Protocol'], key: 'protocol' },
        { header: ['Biometrie', 'Gedruppeld'], key: 'patientGedruppeld' },

        { header: ['Analist', 'Uitv. organisatie ID'], key: 'holterAnalystOrganizationTxcsId' },
        { header: ['Analist', 'Uitv. organisatienaam'], key: 'holterAnalystOrganizationName' },
        { header: ['Analist', 'Uitv. analist ID'], key: 'holterAnalystPractitionerUid' },
        { header: ['Analist', 'Uitv. analistnaam'], key: 'holterAnalystPractitionerName' },

        { header: ['Grading', 'Verzenddatum'], key: 'gradingDate', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Grading', 'Reden geen uitb.'], key: 'gradingPayoutError' },
        { header: ['Grading', 'Reden geen uitb. ingest.'], key: 'gradingPayoutMutationReason' },
        { header: ['Grading', 'Uitv. grp. naam'], key: 'nameGroupReport' },
        { header: ['Grading', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupReportGrader' },
        { header: ['Grading', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupReportGrader' },
        { header: ['Grading', 'Uitv. grp. prijs'], key: 'compensationPayoutReportGraderGroupSetting' },
        { header: ['Grading', 'Uitv. organisatie ID'], key: 'gradingOrganizationTxcsId' },
        { header: ['Grading', 'Uitv. organisatienaam'], key: 'gradingOrganizationName' },
        { header: ['Grading', 'Uitv. org. relatienr'], key: 'gradingOrganizationRelationNumber' },
        { header: ['Grading', 'Uitv. org. prijs'], key: 'compensationPayoutReportGraderOrganizationSetting' },
        { header: ['Grading', 'Uitv. org. emailadres'], key: 'gradingOrganizationEmailAddressRequestInbox' },
        { header: ['Grading', 'Uitv. org. fin. email'], key: 'gradingOrganizationEmailAddressPayouts' },
        { header: ['Grading', 'Uitv. grader ID'], key: 'gradingPractitionerUid' },
        { header: ['Grading', 'Uitv. gradernaam'], key: 'gradingPractitionerName' },
        { header: ['Grading', 'Uitv. prijs'], key: 'compensationPayoutGra' },
        { header: ['Grading', 'Uitv. relatienr'], key: 'graderEmploymentRelationNumber' },
        { header: ['Grading', 'Pers. emailadres'], key: 'gradingPractitionerEmailAddress' },
        { header: ['Grading', 'Financieel emailadres'], key: 'graderEmploymentEmailAddress' },
        { header: ['Grading', 'Diagnostische overweging'], key: 'gradingDiagnosisConsideration' },
        { header: ['Grading', 'NPDR Bevinding OD'], key: 'bevindingenNpdrOd' },
        { header: ['Grading', 'NPDR Bevinding OS'], key: 'bevindingenNpdrOs' },
        { header: ['Grading', 'Maculopathie OD'], key: 'maculopathieOd' },
        { header: ['Grading', 'Maculopathie OS'], key: 'maculopathieOs' },
        { header: ['Grading', 'Retinopathie OD'], key: 'retinopathieOd' },
        { header: ['Grading', 'Retinopathie OS'], key: 'retinopathieOs' },
        { header: ['Grading', 'Advies'], key: 'geadviseerdBeleid' },
        { header: ['Grading', 'Urgentie advies'], key: 'urgentie' },
        { header: ['Grading', 'Glaucoom Ja-Nee-Suspect'], key: 'glaucoom' },

        {
            header: ['Supervisie', 'Verzenddatum'],
            key: 'supervisionDate',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Supervisie', 'Reden geen uitb.'], key: 'supervisionPayoutError' },
        { header: ['Supervisie', 'Reden geen uitb. ingest.'], key: 'supervisionPayoutMutationReason' },
        { header: ['Supervisie', 'Uitv. grp. naam'], key: 'nameGroupSupervision' },
        { header: ['Supervisie', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupSupervision' },
        { header: ['Supervisie', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupSupervision' },
        { header: ['Supervisie', 'Uitv. grp. prijs'], key: 'compensationPayoutSupervisionGroupSetting' },
        { header: ['Supervisie', 'Uitv. organisatie ID'], key: 'supervisionOrganizationTxcsId' },
        { header: ['Supervisie', 'Uitv. organisatienaam'], key: 'supervisionOrganizationName' },
        { header: ['Supervisie', 'Uitv. org. emailadress'], key: 'supervisionOrganizationEmailAddressRequestInbox' },
        { header: ['Supervisie', 'Uitv. org. fin. email'], key: 'supervisionOrganizationEmailAddressPayouts' },
        { header: ['Supervisie', 'Uitv. supervisor ID'], key: 'supervisionPractitionerUid' },
        { header: ['Supervisie', 'Uitv. supervisornaam'], key: 'supervisionPractitionerName' },
        { header: ['Supervisie', 'Uitv. prijs'], key: 'compensationPayoutSupervisor' },
        { header: ['Supervisie', 'Uitv. relatienr'], key: 'supervisorEmploymentRelationNumber' },
        { header: ['Supervisie', 'Toelichting kwaliteitscontrole'], key: 'supervisionToelichtingKwaliteitscontrole' },
        { header: ['Supervisie', 'NPDR Bevinding OD'], key: 'supervisionBevindingenNpdrOd' },
        { header: ['Supervisie', 'NPDR Bevinding OS'], key: 'supervisionBevindingenNpdrOs' },
        { header: ['Supervisie', 'Maculopathie OD'], key: 'supervisionMaculopathieOd' },
        { header: ['Supervisie', 'Maculopathie OS'], key: 'supervisionMaculopathieOs' },
        { header: ['Supervisie', 'Retinopathie OD'], key: 'supervisionRetinopathieOd' },
        { header: ['Supervisie', 'Retinopathie OS'], key: 'supervisionRetinopathieOs' },
        { header: ['Supervisie', 'Advies'], key: 'supervisionGeadviseerdBeleid' },
        { header: ['Supervisie', 'Urgentie advies'], key: 'supervisionUrgentie' },
        { header: ['Supervisie', 'Pers. emailadres'], key: 'supervisionPractitionerEmailAddress' },
        { header: ['Supervisie', 'Financieel emailadres'], key: 'supervisorEmploymentEmailAddress' },
        { header: ['Supervisie', 'Kwaliteit biometrie'], key: 'supervisionAccessmentBiometrics' },
        { header: ['Supervisie', 'Diagnostische overweging'], key: 'supervisionDiagnosisConsideration' },

        { header: ['Consult', 'Verzenddatum'], key: 'consultDate', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Consult', 'Reden geen uitb.'], key: 'consultPayoutError' },
        { header: ['Consult', 'Reden geen uitb. ingest.'], key: 'consultPayoutMutationReason' },
        { header: ['Consult', 'Uitv. grp. naam'], key: 'nameGroupReport' },
        { header: ['Consult', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupReportSpecialist' },
        { header: ['Consult', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupReportSpecialist' },
        { header: ['Consult', 'Uitv. grp. prijs'], key: 'compensationPayoutReportSpecialistGroupSetting' },
        { header: ['Consult', 'Uitv. organisatie ID'], key: 'consultOrganizationTxcsId' },
        { header: ['Consult', 'Uitv. organisatienaam'], key: 'consultOrganizationName' },
        { header: ['Consult', 'Uitv. org. relatienr'], key: 'consultOrganizationRelationNumber' },
        { header: ['Consult', 'Uitv. org. prijs'], key: 'compensationPayoutReportSpecialistOrganizationSetting' },
        { header: ['Consult', 'Uitv. org. emailadres'], key: 'consultOrganizationEmailAddressRequestInbox' },
        { header: ['Consult', 'Uitv. org. fin. email'], key: 'consultOrganizationEmailAddressPayouts' },
        { header: ['Consult', 'Uitv. specialist ID'], key: 'consultPractitionerUid' },
        { header: ['Consult', 'Uitv. specialistnaam'], key: 'consultPractitionerName' },
        { header: ['Consult', 'Uitv. prijs'], key: 'compensationPayoutReportSpec' },
        { header: ['Consult', 'Uitv. relatienr'], key: 'consultPractitionerEmploymentRelationNumber' },
        { header: ['Consult', 'Pers. emailadres'], key: 'consultPractitionerEmailAddress' },
        { header: ['Consult', 'Financieel emailadres'], key: 'consultPractitionerEmploymentEmailAddress' },
        { header: ['Consult', 'Bez. spec. nodig?'], key: 'consultBezoekAanSpecialistNodig' },
        { header: ['Consult', 'Beleid'], key: 'consultBeleid' },

        { header: ['Factuur Org/Grp', 'Te fact. bedrag'], key: 'invoiceAmount' },
        { header: ['Factuur Org/Grp', 'Batch-run'], key: 'invoiceRunNumber' },

        { header: ['Factuur Patient', 'Te fact. bedrag'], key: 'patientInvoiceAmount' },
        { header: ['Factuur Patient', 'Batch-run'], key: 'patientInvoiceRunNumber' },

        { header: ['Declaratie', 'Te decl. bedrag'], key: 'declarationAmount' },
        { header: ['Declaratie', 'UZOVI'], key: 'uzoviCode' },
        { header: ['Declaratie', 'Verzekeraar'], key: 'insurer' },
        { header: ['Declaratie', 'Batch-run'], key: 'runNumber' },

        { header: ['Uitbetaling', 'Relatienr. Aanvrager'], key: 'payoutRelationNumberRequester' },
        { header: ['Uitbetaling', 'Aanvraag'], key: 'payoutAmountRequester' },
        { header: ['Uitbetaling', 'Aanvraag Batch-run'], key: 'runNumberRequester' },
        { header: ['Uitbetaling', 'Relatienr. biometrie'], key: 'payoutRelationNumberBiometrician' },
        { header: ['Uitbetaling', 'Biometrie'], key: 'payoutAmountBiometrician' },
        { header: ['Uitbetaling', 'Biometrie Batch-run'], key: 'runNumberBiometrician' },
        { header: ['Uitbetaling', 'Relatienr. grader'], key: 'payoutRelationNumberGrader' },
        { header: ['Uitbetaling', 'Grading'], key: 'payoutAmountGrader' },
        { header: ['Uitbetaling', 'Grader Batch-run'], key: 'runNumberGrader' },
        { header: ['Uitbetaling', 'Relatienr. specialist'], key: 'payoutRelationNumberSpecialist' },
        { header: ['Uitbetaling', 'Consult'], key: 'payoutAmountSpecialist' },
        { header: ['Uitbetaling', 'Specialist Batch-run'], key: 'runNumberSpecialist' },
        { header: ['Uitbetaling', 'Relatienr. supervisie'], key: 'payoutRelationNumberSupervisor' },
        { header: ['Uitbetaling', 'Supervisor'], key: 'payoutAmountSupervisor' },
        { header: ['Uitbetaling', 'Supervisor Batch-run'], key: 'runNumberSupervisor' },

        { header: ['Instellingen', 'Org. bio. altern. bek.'], key: 'procedureServiceOrganizationAlternativeFinancing' },
        {
            header: ['Instellingen', 'Org. grad/spec. altern. bek.'],
            key: 'reportServiceOrganizationAlternativeFinancing',
        },
        { header: ['Instellingen', 'Org. bio. fact.'], key: 'procedureServiceOrganizationInvoice' },
        { header: ['Instellingen', 'Org. grad/spec. fact.'], key: 'reportServiceOrganizationInvoice' },
        { header: ['Instellingen', 'Grp. altern. bek.'], key: 'serviceGroupAlternativeFinancing' },
        { header: ['Instellingen', 'Grp. fact.'], key: 'serviceGroupFact' },
        { header: ['Instellingen', 'Aanvr. grp'], key: 'groupName' },
        { header: ['Instellingen', 'Uitv. biom. grp'], key: 'nameGroupProcedure' },
        { header: ['Instellingen', 'Uitv. gr/cs. grp'], key: 'nameGroupReport' },
        { header: ['Instellingen', 'Patient facturatie'], key: 'serviceIsPatientInvoicing' },
    ];
}

export function getPayoutsReportColumns() {
    return [
        { header: ['Proces', 'Proces ID'], key: 'processId' },
        { header: ['Proces', 'Txcs proces ID'], key: 'txcsProcesId' },
        { header: ['Proces', 'Migratiedatum'], key: 'migrationDateTime' },
        { header: ['Proces', 'Mogelijk testgeval'], key: 'processTestCase' },
        { header: ['Proces', 'Dienst'], key: 'serviceName' },
        { header: ['Proces', 'Indirecte aanvraag'], key: 'isDirectProcedureAdded' },
        { header: ['Proces', 'Creatiedatum'], key: 'creatieDatum', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Proces', 'Status'], key: 'status' },
        {
            header: ['Proces', 'Aanvraag verzonden'],
            key: 'datumVerzending',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Proces', 'Sluitdatum'], key: 'sluitDatum', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },

        { header: ['Aanvraag', 'Verzenddatum'], key: 'dateSent' },
        { header: ['Aanvraag', 'Reden geen uitb.'], key: 'requestPayoutError' },
        { header: ['Aanvraag', 'Reden geen uitb. ingest.'], key: 'requestPayoutMutationReason' },
        { header: ['Aanvraag', 'Aanv. organisatie ID'], key: 'requesterOrganizationTxcsId' },
        { header: ['Aanvraag', 'Aanv. organisatienaam'], key: 'requesterOrganizationName' },
        { header: ['Aanvraag', 'Verwijst naar'], key: 'refersTo' },
        { header: ['Aanvraag', 'Aanv. org. relatienr.'], key: 'requesterOrganizationRelationNumber' },
        {
            header: ['Aanvraag', 'Aanv. org. prijs'],
            key: 'requesterServiceOrganizationSettingCompensationPayoutRequest',
        },
        { header: ['Aanvraag', 'Aanv. org. emailadres'], key: 'requesterOrganizationEmailAddressRequestInbox' },
        { header: ['Aanvraag', 'Aanv. org. fin. email'], key: 'requesterOrganizationEmailAddressPayouts' },
        { header: ['Aanvraag', 'Aanv. grp. naam'], key: 'groupName' },
        { header: ['Aanvraag', 'Aanv. grp. relatienr.'], key: 'groupRelationNumber' },
        { header: ['Aanvraag', 'Aanv. grp. fin. email'], key: 'groupFinancialEmailAddress' },
        { header: ['Aanvraag', 'Aanv. grp. prijs'], key: 'compensationPayoutRequestGroupSetting' },
        { header: ['Aanvraag', 'Aanvrager ID'], key: 'requesterPractitionerUid' },
        { header: ['Aanvraag', 'Aanvragernaam'], key: 'requesterPractitionerName' },
        { header: ['Aanvraag', 'Uitv. prijs'], key: 'serviceConsumerCompensationPayoutRequest' },
        { header: ['Aanvraag', 'Uitv. relatienr'], key: 'requesterEmploymentRelationNumber' },
        { header: ['Aanvraag', 'Pers. Emailadres'], key: 'requesterEmploymentEmailAddress' },
        { header: ['Aanvraag', 'Financieel emailadres'], key: 'requesterEmploymentEmailAddressPayouts' },

        {
            header: ['Biometrie', 'Verzenddatum'],
            key: 'procedureDate',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Biometrie', 'Reden geen uitb.'], key: 'procedurePayoutError' },
        { header: ['Biometrie', 'Reden geen uitb. ingest.'], key: 'procedurePayoutMutationReason' },
        { header: ['Biometrie', 'Uitv. grp. naam'], key: 'nameGroupProcedure' },
        { header: ['Biometrie', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupProcedure' },
        { header: ['Biometrie', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupProcedure' },
        { header: ['Biometrie', 'Uitv. grp. prijs'], key: 'compensationPayoutProcedureGroupSetting' },
        { header: ['Biometrie', 'Uitv. organisatie ID'], key: 'procedureOrganizationTxcsId' },
        { header: ['Biometrie', 'Uitv. organisatienaam'], key: 'procedureOrganizationName' },
        { header: ['Biometrie', 'Uitv. org. relatienr'], key: 'procedureOrganizationRelationNumber' },
        { header: ['Biometrie', 'Uitv. org. prijs'], key: 'compensationPayoutBioOrganizationSetting' },
        { header: ['Biometrie', 'Uitv. org. emailadres'], key: 'procedureOrganizationEmailAddressRequestInbox' },
        { header: ['Biometrie', 'Uitv. org. fin. email'], key: 'procedureOrganizationEmailAddressPayouts' },
        { header: ['Biometrie', 'Uitv. biometrist ID'], key: 'procedurePractitionerUid' },
        { header: ['Biometrie', 'Uitv. biometristnaam'], key: 'procedurePractitionerName' },
        { header: ['Biometrie', 'Uitv. prijs'], key: 'compensationPayoutBio' },
        { header: ['Biometrie', 'Uitv. relatienr'], key: 'procedureEmploymentRelationNumber' },
        { header: ['Biometrie', 'Pers. emailadres'], key: 'procedurePractitionerEmailAddress' },
        { header: ['Biometrie', 'Financieel emailadres'], key: 'procedureEmploymentEmailAddress' },
        { header: ['Biometrie', 'Protocol'], key: 'protocol' },
        { header: ['Biometrie', 'Gedruppeld'], key: 'patientGedruppeld' },

        { header: ['Grading', 'Verzenddatum'], key: 'gradingDate', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Grading', 'Reden geen uitb.'], key: 'gradingPayoutError' },
        { header: ['Grading', 'Reden geen uitb. ingest.'], key: 'gradingPayoutMutationReason' },
        { header: ['Grading', 'Uitv. grp. naam'], key: 'nameGroupReport' },
        { header: ['Grading', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupReportGrader' },
        { header: ['Grading', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupReportGrader' },
        { header: ['Grading', 'Uitv. grp. prijs'], key: 'compensationPayoutReportGraderGroupSetting' },
        { header: ['Grading', 'Uitv. organisatie ID'], key: 'gradingOrganizationTxcsId' },
        { header: ['Grading', 'Uitv. organisatienaam'], key: 'gradingOrganizationName' },
        { header: ['Grading', 'Uitv. org. relatienr'], key: 'gradingOrganizationRelationNumber' },
        { header: ['Grading', 'Uitv. org. prijs'], key: 'compensationPayoutReportGraderOrganizationSetting' },
        { header: ['Grading', 'Uitv. org. emailadres'], key: 'gradingOrganizationEmailAddressRequestInbox' },
        { header: ['Grading', 'Uitv. org. fin. email'], key: 'gradingOrganizationEmailAddressPayouts' },
        { header: ['Grading', 'Uitv. grader ID'], key: 'gradingPractitionerUid' },
        { header: ['Grading', 'Uitv. gradernaam'], key: 'gradingPractitionerName' },
        { header: ['Grading', 'Uitv. prijs'], key: 'compensationPayoutGra' },
        { header: ['Grading', 'Uitv. relatienr'], key: 'graderEmploymentRelationNumber' },
        { header: ['Grading', 'Pers. emailadres'], key: 'gradingPractitionerEmailAddress' },
        { header: ['Grading', 'Financieel emailadres'], key: 'graderEmploymentEmailAddress' },

        {
            header: ['Supervisie', 'Verzenddatum'],
            key: 'supervisionDate',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Supervisie', 'Reden geen uitb.'], key: 'supervisionPayoutError' },
        { header: ['Supervisie', 'Reden geen uitb. ingest.'], key: 'supervisionPayoutMutationReason' },
        { header: ['Supervisie', 'Uitv. grp. naam'], key: 'nameGroupSupervision' },
        { header: ['Supervisie', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupSupervision' },
        { header: ['Supervisie', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupSupervision' },
        { header: ['Supervisie', 'Uitv. grp. prijs'], key: 'compensationPayoutSupervisionGroupSetting' },
        { header: ['Supervisie', 'Uitv. organisatie ID'], key: 'supervisionOrganizationTxcsId' },
        { header: ['Supervisie', 'Uitv. organisatienaam'], key: 'supervisionOrganizationName' },
        { header: ['Supervisie', 'Uitv. org. emailadress'], key: 'supervisionOrganizationEmailAddressRequestInbox' },
        { header: ['Supervisie', 'Uitv. org. fin. email'], key: 'supervisionOrganizationEmailAddressPayouts' },
        { header: ['Supervisie', 'Uitv. supervisor ID'], key: 'supervisionPractitionerUid' },
        { header: ['Supervisie', 'Uitv. supervisornaam'], key: 'supervisionPractitionerName' },
        { header: ['Supervisie', 'Uitv. prijs'], key: 'compensationPayoutSupervisor' },
        { header: ['Supervisie', 'Uitv. relatienr'], key: 'supervisorEmploymentRelationNumber' },
        { header: ['Supervisie', 'Financieel emailadres'], key: 'supervisorEmploymentEmailAddress' },

        { header: ['Consult', 'Verzenddatum'], key: 'consultDate', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Consult', 'Reden geen uitb.'], key: 'consultPayoutError' },
        { header: ['Consult', 'Reden geen uitb. ingest.'], key: 'consultReportPayoutMutationReason' },
        { header: ['Consult', 'Uitv. grp. naam'], key: 'nameGroupReport' },
        { header: ['Consult', 'Uitv. grp. relatienr.'], key: 'relationNumberGroupReportSpecialist' },
        { header: ['Consult', 'Uitv. grp. fin. email'], key: 'financialEmailAddressGroupReportSpecialist' },
        { header: ['Consult', 'Uitv. grp. prijs'], key: 'compensationPayoutReportSpecialistGroupSetting' },
        { header: ['Consult', 'Uitv. organisatie ID'], key: 'consultOrganizationTxcsId' },
        { header: ['Consult', 'Uitv. organisatienaam'], key: 'consultOrganizationName' },
        { header: ['Consult', 'Uitv. org. relatienr.'], key: 'consultOrganizationRelationNumber' },
        { header: ['Consult', 'Uitv. org. prijs'], key: 'compensationPayoutReportSpecialistOrganizationSetting' },
        { header: ['Consult', 'Uitv. org. emailadres'], key: 'consultOrganizationEmailAddressRequestInbox' },
        { header: ['Consult', 'Uitv. org. fin. email'], key: 'consultOrganizationEmailAddressPayouts' },
        { header: ['Consult', 'Uitv. specialist ID'], key: 'consultPractitionerUid' },
        { header: ['Consult', 'Uitv. specialistnaam'], key: 'consultPractitionerName' },
        { header: ['Consult', 'Uitv. prijs'], key: 'compensationPayoutReportSpec' },
        { header: ['Consult', 'Uitv. relatienr'], key: 'consultPractitionerEmploymentRelationNumber' },
        { header: ['Consult', 'Pers. emailadres'], key: 'consultPractitionerEmailAddress' },
        { header: ['Consult', 'Financieel emailadres'], key: 'consultPractitionerEmploymentEmailAddress' },

        { header: ['Uitbetaling', 'Relatienr. Aanvrager'], key: 'payoutRelationNumberRequester' },
        { header: ['Uitbetaling', 'Aanvraag'], key: 'payoutAmountRequester' },
        { header: ['Uitbetaling', 'Aanvraag Batch-run'], key: 'runNumberRequester' },
        { header: ['Uitbetaling', 'Relatienr. biometrie'], key: 'payoutRelationNumberBiometrician' },
        { header: ['Uitbetaling', 'Biometrie'], key: 'payoutAmountBiometrician' },
        { header: ['Uitbetaling', 'Biometrie Batch-run'], key: 'runNumberBiometrician' },
        { header: ['Uitbetaling', 'Relatienr. grader'], key: 'payoutRelationNumberGrader' },
        { header: ['Uitbetaling', 'Grading'], key: 'payoutAmountGrader' },
        { header: ['Uitbetaling', 'Grader Batch-run'], key: 'runNumberGrader' },
        { header: ['Uitbetaling', 'Relatienr. specialist'], key: 'payoutRelationNumberSpecialist' },
        { header: ['Uitbetaling', 'Consult'], key: 'payoutAmountSpecialist' },
        { header: ['Uitbetaling', 'Specialist Batch-run'], key: 'runNumberSpecialist' },
        { header: ['Uitbetaling', 'Relatienr. supervisie'], key: 'payoutRelationNumberSupervisor' },
        { header: ['Uitbetaling', 'Supervisor'], key: 'payoutAmountSupervisor' },
        { header: ['Uitbetaling', 'Supervisor Batch-run'], key: 'runNumberSupervisor' },
    ];
}

export function getFundingReportColumns() {
    return [
        { header: ['Proces', 'Proces ID'], key: 'processId' },
        { header: ['Proces', 'Txcs proces ID'], key: 'txcsProcesId' },
        { header: ['Proces', 'Migratiedatum'], key: 'migrationDateTime' },
        { header: ['Proces', 'Mogelijk testgeval'], key: 'processTestCase' },
        { header: ['Proces', 'Dienst'], key: 'serviceName' },
        { header: ['Proces', 'Indirecte aanvraag'], key: 'isDirectProcedureAdded' },
        { header: ['Proces', 'Aanvragende organisatie ID'], key: 'requesterOrganizationTxcsId' },
        { header: ['Proces', 'Aanvragende organisatienaam'], key: 'requesterOrganizationName' },
        { header: ['Proces', 'Aanvragende zorgverlener ID'], key: 'requesterPractitionerUid' },
        { header: ['Proces', 'Aanvragende zorgverlenersnaam'], key: 'requesterPractitionerName' },
        { header: ['Proces', 'Creatiedatum'], key: 'creatieDatum', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Proces', 'Status'], key: 'status' },
        {
            header: ['Proces', 'Aanvraag verzonden'],
            key: 'datumVerzending',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Proces', 'Sluitdatum'], key: 'sluitDatum', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Proces', 'Reden geen bekosting'], key: 'reasonNoInvoiceOrDeclaration' },
        { header: ['Proces', 'Reden geen bek. ingest.'], key: 'fundingMutationReason' },
        { header: ['Proces', 'Bekostingsfout'], key: 'fundingError' },
        { header: ['Proces', 'Afhandelingsinformatie'], key: 'fundingErrorInformation' },
        { header: ['Proces', '=> consult?'], key: 'previousRequestId' },

        { header: ['Aanvraag', 'Aanv. grp. naam'], key: 'groupName' },

        { header: ['Patient', 'Patient ID'], key: 'patientId' },
        { header: ['Patient', 'Huisartsnaam'], key: 'careProviderPractitioner' },

        { header: ['Biometrie', 'Uitv. grp. naam'], key: 'nameGroupProcedure' },
        {
            header: ['Biometrie', 'Verzenddatum'],
            key: 'procedureDate',
            style: { numFmt: 'YYYY-MM-DD HH:mm' },
            width: 16,
        },
        { header: ['Biometrie', 'Uitvoerende organisatie ID'], key: 'procedureOrganizationTxcsId' },
        { header: ['Biometrie', 'Uitvoerende organisatienaam'], key: 'procedureOrganizationName' },
        { header: ['Biometrie', 'Uitvoerende biometrist ID'], key: 'procedurePractitionerUid' },
        { header: ['Biometrie', 'Uitvoerende biometristnaam'], key: 'procedurePractitionerName' },
        { header: ['Biometrie', 'Revers. test afg.'], key: 'reverseTest' },
        { header: ['Biometrie', 'Ketenpatiënt'], key: 'ketenPatient' },

        { header: ['Grading', 'Uitv. grp. naam'], key: 'nameGroupReport' },
        { header: ['Grading', 'Verzenddatum'], key: 'gradingDate', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Grading', 'Uitvoerende organisatie ID'], key: 'gradingOrganizationTxcsId' },
        { header: ['Grading', 'Uitvoerende organisatienaam'], key: 'gradingOrganizationName' },
        { header: ['Grading', 'Uitvoerende grader ID'], key: 'gradingPractitionerUid' },
        { header: ['Grading', 'Uitvoerende gradernaam'], key: 'gradingPractitionerName' },

        { header: ['Consult', 'Uitv. grp. naam'], key: 'nameGroupReport' },
        { header: ['Consult', 'Uitv. org. emailadres'], key: 'consultOrganizationEmailAddressRequestInbox' },
        { header: ['Consult', 'Verzenddatum'], key: 'consultDate', style: { numFmt: 'YYYY-MM-DD HH:mm' }, width: 16 },
        { header: ['Consult', 'Uitvoerende organisatie ID'], key: 'consultOrganizationTxcsId' },
        { header: ['Consult', 'Uitvoerende organisatienaam'], key: 'consultOrganizationName' },
        { header: ['Consult', 'Uitvoerende specialist ID'], key: 'consultPractitionerUid' },
        { header: ['Consult', 'Uitvoerende specialistnaam'], key: 'consultPractitionerName' },

        { header: ['Supervisie', 'Uitv. grp. naam'], key: 'nameGroupSupervision' },
        { header: ['Supervisie', 'Uitv. org. emailadress'], key: 'supervisionOrganizationEmailAddressRequestInbox' },

        { header: ['Factuur Org/Grp', 'Te fact. bedrag'], key: 'invoiceAmount' },
        { header: ['Factuur Org/Grp', 'Batch-run'], key: 'invoiceRunNumber' },

        { header: ['Factuur Patient', 'Te fact. bedrag'], key: 'patientInvoiceAmountInvoiceAmount' },
        { header: ['Factuur Patient', 'Batch-run'], key: 'patientInvoiceRunNumber' },

        { header: ['Declaratie', 'Te decl. bedrag'], key: 'declarationAmount' },
        { header: ['Declaratie', 'UZOVI'], key: 'uzoviCode' },
        { header: ['Declaratie', 'Verzekeraar'], key: 'insurer' },
        { header: ['Declaratie', 'Batch-run'], key: 'runNumber' },

        { header: ['Instellingen', 'Org. bio. altern. bek.'], key: 'procedureServiceOrganizationAlternativeFinancing' },
        {
            header: ['Instellingen', 'Org. grad/spec. altern. bek.'],
            key: 'reportServiceOrganizationAlternativeFinancing',
        },
        { header: ['Instellingen', 'Org. bio. fact.'], key: 'procedureServiceOrganizationInvoice' },
        { header: ['Instellingen', 'Org. grad/spec. fact.'], key: 'reportServiceOrganizationInvoice' },
        { header: ['Instellingen', 'Grp. altern. bek.'], key: 'serviceGroupAlternativeFinancing' },
        { header: ['Instellingen', 'Grp. fact.'], key: 'serviceGroupFact' },
        { header: ['Instellingen', 'Patient facturatie'], key: 'serviceIsPatientInvoicing' },
    ];
}
